module.exports = __webpack_public_path__ + "img/relatus_orange_logo_horizontal.fcceeded.png";